const originalConsoleLog = console.log.bind(console);

function maskSensitive(message: string): string {
  return message
    .replace(/(Decoded file path:).*/gi, '$1 ****')
    .replace(/(Forced Signed URL:).*/gi, '$1 ****')
    .replace(/\/c:\/Users\/zhant\/OneDrive\/Desktop\/project_fix\/projectbase1\.3\/\S+/gi, '****');
}

export function safeConsoleLog(...args: any[]): void {
  // If first argument is a sensitive label and there is a second argument, override it.
  if (args.length >= 2 && typeof args[0] === 'string') {
    const label = args[0].toLowerCase();
    if (label.includes('decoded file path:') || label.includes('forced signed url:')) {
      args[1] = '****';
    }
  }
  const maskedArgs = args.map(arg => {
    if (typeof arg === 'string') return maskSensitive(arg);
    if (typeof arg === 'object' && arg !== null) {
      try {
        return maskSensitive(JSON.stringify(arg));
      } catch {
        return arg;
      }
    }
    return arg;
  });
  originalConsoleLog(...maskedArgs);
}
